import { Component, input, InputSignal } from '@angular/core';
import { StepperCircleProgress } from '../stepper-circle-progress/stepper-circle-progress';
import { TranslateModule } from '@ngx-translate/core';
import { IconType } from '../icon/icon';

@Component({
  selector: 'app-stepper-item',
  imports: [StepperCircleProgress, TranslateModule],
  template: `
    <app-stepper-circle-progress
      [icon]="icon()"
      [completionPercent]="completionPercent()"
      [stepIndex]="stepIndex()"
    />
    <span [innerHTML]="content() | translate"></span>
    @if (!isLast()) {
      <div class="stepper-divider"></div>
    }
  `,
  styleUrl: './stepper-item.scss',
  host: {
    '[style.--divider-size]': 'dividerWidth',
  },
})
export class StepperItem {
  isLast: InputSignal<boolean> = input(false);
  icon: InputSignal<IconType> = input.required();
  stepIndex: InputSignal<number> = input(0);
  completionPercent: InputSignal<number> = input<number>(0);
  dividerSize: InputSignal<'s' | 'm' | 'l' | 'xl'> = input<'s' | 'm' | 'l' | 'xl'>('m');
  content: InputSignal<string> = input('');

  get dividerWidth(): string {
    switch (this.dividerSize()) {
      case 's':
        return '1rem';
      case 'm':
        return '4rem';
      case 'l':
        return '7rem';
      case 'xl':
        return '10rem';
    }
  }
}
